export default "__VITE_ASSET__adEX2iU1__"